import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'

const tbcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Product',
    field: 'product',
    sort: 'asc',
  },
  {
    label: 'Total Sessions',
    field: 'total_sessions',
    sort: 'asc',
  },
  {
    label: 'Left Sessions',
    field: 'left_sessions',
    sort: 'asc',
  },
  {
    label: 'Start Contract',
    field: 'start_dt',
    sort: 'asc',
  },
  {
    label: 'End Contract',
    field: 'end_dt',
    sort: 'asc',
  },
  {
    label: 'Last Service',
    field: 'last_service_dt',
    sort: 'asc',
  },
  {
    label: 'Due',
    field: 'due_dt',
    sort: 'asc',
  },

  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class ContractOrder extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      customerModal: false,
      dataModal: false,
      orderList: [],
      selectedData: '',
    }
  }

  toggleCustomer = data => () => {
    return this.setState({
      customerModal: !this.state.customerModal,
      selectedData: data,
    })
  }

  toggleData = data => () => {
    return this.setState({
      dataModal: !this.state.dataModal,
      selectedData: data,
    })
  }

  componentDidMount() {
    this.contractOrder()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  contractOrder = async date => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      limit: 100,
    }
    const response = await axios.post(url + ':3003/v1/order/contract', data)
    const result = response.data
    if (result.error == true && result.message != 'Success') {
      alert(result.message)
      return
    }
    if (this._isMounted) {
      for (let i of result.data) {
        if (i.start_dt) {
          i.start_dt = moment(i.start_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
        }
        if (i.end_dt) {
          i.end_dt = moment(i.end_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
        }
        if (i.last_service_dt) {
          i.last_service_dt = moment(i.last_service_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
        }
        if (i.due_dt) {
          i.due_dt = moment(i.due_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
        }

        i.Action = (
          <div className="ps-action-button">
            <Button className="theme-button theme-button-primary" onClick={this.toggleCustomer(i.customer)}>
              Customer
            </Button>
            <Button className="theme-button theme-button-primary-light" onClick={this.toggleData(i.data)}>
              Data
            </Button>
            <Button className="theme-button theme-button-secondary" onClick={() => this.props.history.push(`/posorder/store/${this.props.match.params.id}/contract/${i.data_id}/${i.product_id}`)}>
              Detail
            </Button>
          </div>
        )
      }
      this.setState({
        orderList: result.data,
      })
    }
  }

  render() {
    const data = {
      columns: tbcolumn,
      rows: this.state.orderList,
    }
    return (
      <>
        <MDBDataTableV5 className="ps-order-table th-9" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
        <Modal isOpen={this.state.customerModal} className={this.props.className} toggle={this.toggleCustomer(this.state.selectedData)} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleCustomer(this.state.selectedData)}>Customer Detail</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Category</Label>
                  <Input type="text" name="category" value={this.state.selectedData.category} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Membership ID</Label>
                  <Input type="text" name="membership_id" value={this.state.selectedData.membership_id} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Name</Label>
                  <Input type="text" name="name" value={this.state.selectedData.name} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Company</Label>
                  <Input type="text" name="company" value={this.state.selectedData.company} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Contact</Label>
                  <Input type="text" name="contact" value={this.state.selectedData.contact} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Email</Label>
                  <Input type="email" name="email" value={this.state.selectedData.email} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Billing Address</Label>
                  <Input type="text" name="billing_address" value={this.state.selectedData.billing_address} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Billing Unit</Label>
                  <Input type="text" name="billing_unit" value={this.state.selectedData.billing_unit} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Billing Country</Label>
                  <Input type="text" name="billing_country" value={this.state.selectedData.billing_country} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Billing Postal Code</Label>
                  <Input type="text" maxLength="6" name="billing_postal_code" value={this.state.selectedData.billing_postal_code} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Remarks</Label>
                  <Input type="text" name="remarks" value={this.state.selectedData.remarks} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Date of Birth</Label>
                  <Input type="text" name="remarks" value={this.state.selectedData.dob} readOnly />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={() => this.setState({ customerModal: false })}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.dataModal} className={this.props.className} toggle={this.toggleData(this.state.selectedData)} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleData(this.state.selectedData)}>Data</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Model</Label>
                  <Input type="text" name="category" value={this.state.selectedData.model} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Serial</Label>
                  <Input type="text" name="membership_id" value={this.state.selectedData.serial} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Install Date</Label>
                  <Input type="date" name="name" value={this.state.selectedData.install_date} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Brand</Label>
                  <Input type="text" name="company" value={this.state.selectedData.brand} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Postal Code</Label>
                  <Input type="text" name="contact" value={this.state.selectedData.postal_code} readOnly />
                </FormGroup>
                <FormGroup>
                  <Label>Unit</Label>
                  <Input type="text" name="unit" value={this.state.selectedData.unit} readOnly />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={() => this.setState({ customerModal: false })}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}

export default ContractOrder
